const onDeinitHandler = () => {
    window.WC._localStorage.clearAll();
    window.WC._sessionStorage.clearAll();
    window.WC.Closer._isInitialized = false;
};

export { onDeinitHandler };
